<script lang="ts">
import GenericButton from "@/Components/Generics/GenericButton.vue";
import Plane from "@/Components/Generics/Plane.vue";
import MainPage from "@/Components/MainPage.vue";
import BreezeValidationErrors from "@/Components/ValidationErrors.vue";
import App from "@/Layouts/App.vue";
import { defineComponent } from "vue";

export default defineComponent({
    name: "LoginVue",
    components: {
        BreezeValidationErrors,
        Plane,
        MainPage,
        GenericButton,
    },
    layout: App,
    props: {
        canResetPassword: {
            type: Boolean,
            required: true,
        },
        status: {
            type: String,
            default: null,
        },
    },
    data() {
        return {
            form: this.$inertia.form({
                email: "",
                password: "",
                remember: false,
            }),
        };
    },
    methods: {
        submit(): void {
            this.form.post(this.route("login"), {
                onFinish: () => this.form.reset("password"),
            });
        },
    },
});
</script>

<template>
    <MainPage :title="$trans('auth.login')" :gap="false">
        <Plane class="login-plane" :darker="true">
            <div class="flex flex--width flex--v flex--gap-20">
                <BreezeValidationErrors />

                <div v-if="status" class="text text--accent-gray-b text--size-18 text--semi-bold text--center">
                    {{ status }}
                </div>

                <form class="full-width" @submit.prevent="submit">
                    <div class="flex flex--v flex--gap-20">
                        <div class="flex flex--v flex--gap-5">
                            <label for="email" class="form-label">{{ $trans("auth.email") }}</label>
                            <input id="email" v-model="form.email" name="email" type="email" class="form-control" required autofocus autocomplete="username" />
                        </div>

                        <div class="flex flex--v flex--gap-5">
                            <label for="password" class="form-label">{{ $trans("auth.password") }}</label>
                            <input id="password" v-model="form.password" name="password" type="password" class="form-control" required autocomplete="current-password" />
                        </div>

                        <div class="form-check">
                            <input id="checkboxRememberMe" v-model="form.remember" class="form-check-input" name="remember" type="checkbox" />
                            <label class="form-check-label" for="checkboxRememberMe">
                                {{ $trans("auth.remember_me") }}
                            </label>
                        </div>

                        <div class="flex flex--width flex--v flex--valign-c flex--gap-20">
                            <GenericButton class="login-button" :title="$trans('auth.login')" :disabled="form.processing" @click="submit" />

                            <div class="flex flex--v flex--valign-c flex--gap-10">
                                <InertiaLink :href="route('register')" class="inertia-link text text--less-gap text--primary-b text--size-16 text--center">{{ $trans("auth.not_registered") }}</InertiaLink>
                                <InertiaLink v-if="canResetPassword" :href="route('password.request')" class="inertia-link text text--less-gap text--primary-b text--size-16 text--center">{{ $trans("auth.forgot_password") }}</InertiaLink>
                            </div>
                        </div>
                    </div>
                </form>
            </div>
        </Plane>
    </MainPage>
</template>

<style lang="scss" scoped>
.login-plane {
    max-width: rem(500);
    margin: 0 auto;

    .login-button {
        height: rem(45);
        margin-top: rem(5);
    }

    .inertia-link {
        &:hover {
            text-decoration: underline;
        }
    }
}
.form-check label {
    line-height: 1.5em;
}
</style>
